import { TicketStatus } from '@/services/TicketsService';

export function getStatusLabel(
  status: TicketStatus,
  labels: Record<TicketStatus, string>,
) {
  return labels[status];
}
